/**
 * 购物车 API
 */

import { unifiedApi } from '@/utils/unifiedApi';

// ==================== 类型定义 ====================

/** 购物车条目 */
export interface CartItem {
  id: number;
  spuId: number;
  skuId: number;
  skuCode: string;
  skuName: string;
  quantity: number;
  unitPrice: number;
  amount: number;
  stock: number;
  warehouseId: number;
  warehouseName: string;
  spuName: string;
  spuCode: string;
  enabled: boolean;
}

/** 购物车列表响应 */
export interface CartListResponse {
  items: CartItem[];
  totalItems: number;
  totalAmount: number;
  totalQuantity: number;
}

/** 加入购物车请求 */
export interface AddToCartParams {
  skuId: number;
  quantity: number;
  warehouseId?: number;
}

/** 结算请求 */
export interface CheckoutParams {
  itemIds: number[];
  deliveryId: number;
  remark?: string;
}

/** 结算响应 */
export interface CheckoutResponse {
  orderIds: number[];
  message: string;
}

// ==================== API ====================

export const cartApi = {
  /** 获取购物车列表 */
  getCartList: () =>
    unifiedApi.get<CartListResponse>('/cart'),

  /** 获取购物车数量 */
  getCartCount: () =>
    unifiedApi.get<{ count: number }>('/cart/count'),

  /** 加入购物车 */
  addToCart: (data: AddToCartParams) =>
    unifiedApi.post('/cart', data),

  /** 更新数量 */
  updateQuantity: (id: number, quantity: number) =>
    unifiedApi.put(`/cart/${id}`, { quantity }),

  /** 删除单条 */
  removeItem: (id: number) =>
    unifiedApi.delete(`/cart/${id}`),

  /** 清空购物车 */
  clearCart: () =>
    unifiedApi.delete('/cart'),

  /** 结算下单 */
  checkout: (data: CheckoutParams) =>
    unifiedApi.post<CheckoutResponse>('/cart/checkout', data),
};

export default cartApi;
